export const ELO_SLIDER_ARROWS_Z_INDEX = 2
